namespace $.$$ {
	export class $mol_audio_demo_sample extends $.$mol_audio_demo_sample {
		override sample_buffer() {
			$mol_wire_solid()

			return this.$.$mol_fetch.response(this.sample_url()).buffer()
		}

		override start_click(e: Event) {
			this.start()
		}
	}
}

